import i18n from 'i18next';
import ukTranslations from '../locales/uk/translations.json';
import ukAdvancedReport from '../locales/uk/advancedReport.json';
import ukAdvancedSearch from '../locales/uk/advancedSearch.json';
import ukAppeal from '../locales/uk/appeal.json';
import enTranslations from '../locales/en/translations.json';
import enAdvancedReport from '../locales/en/advancedReport.json';

export function getUserLanguage() {
	const NAV = navigator;
	let userLanguage = NAV.languages ? NAV.languages[0] : (NAV.language || NAV.userLanguage);

	if (!(userLanguage === 'ru')) {
		userLanguage = 'en';
	}

	return userLanguage;
}

i18n
	.init({
		lng: 'uk',
		defaultNS: 'translations',
		ns: [
			'translations',
			'dictionary',
			'advancedReport',
			'advancedSearch',
			'appeal',
		],
		fallbackLng: 'uk',

		// debug: true,
		interpolation: {
			escapeValue: false,
			formatSeparator: ',',
		},
		resources: {
			uk: {
				translations: ukTranslations,
				advancedReport: ukAdvancedReport,
				advancedSearch: ukAdvancedSearch,
				appeal: ukAppeal,
			},
			en: {
				translations: enTranslations,
				advancedReport: enAdvancedReport,
				advancedSearch: {},
				appeal: {},
			},
		},
		react: {
			wait: true,
		},
	});

i18n.on('languageChanged', lang => console.log('New Language: %s', lang));
i18n.on('added', (lang, namespace) => console.log('Language: %s, Namespace: %s', lang, namespace));

export default i18n;
